import { CUSTOM_APP_BASE_URL } from '../config';

export interface CustomDetailsConfig {
  entityName: string;
  remoteName: string;
  remoteEntry: string;
  remoteModule: string;
  testIdObject: string;
  defaultRouteEntity: string;
}

export const CUSTOM_DETAILS_CONFIGS: CustomDetailsConfig[] = [
  {
    entityName: 'customerShipment',
    remoteName: 'shipment-details',
    remoteEntry: `${CUSTOM_APP_BASE_URL}/shipment-details/mf-manifest.json`,
    remoteModule: 'shipment-details/App',
    testIdObject: 'shipment-details-container',
    defaultRouteEntity: 'shipment',
  },
  {
    entityName: 'logisticOrder',
    remoteName: 'logistic-order-details',
    remoteEntry: `${CUSTOM_APP_BASE_URL}/logistic-order-details/mf-manifest.json`,
    remoteModule: 'logistic-order-details/App',
    testIdObject: 'logistic-order-details-container',
    defaultRouteEntity: 'logistic-order',
  },
];

export function getCustomDetailsConfig(
  entityName?: string
): CustomDetailsConfig | undefined {
  return CUSTOM_DETAILS_CONFIGS.find(
    config => config.entityName === entityName
  );
}
